import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

function LanguageToggle() {
  const { i18n } = useTranslation();

  // Faqat birinchi marta kirganda ingliz tilini o'rnatish
  useEffect(() => {
    const savedLanguage = localStorage.getItem("i18nextLng");
    // Faqat localStorage bo'sh bo'lsa ingliz tilini o'rnat
    if (!savedLanguage) {
      i18n.changeLanguage("en");
      localStorage.setItem("i18nextLng", "en");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Faqat 1 marta ishlashi kerak

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng); // Tanlangan tilni saqlash
  };

  const currentLanguage = i18n.language.split("-")[0];

  return (
    <div
      className="language-toggle"
      style={{
        display: "flex",
        gap: "10px",
        alignItems: "center",
        margin: "0 15px",
      }}
    >
      <button
        onClick={() => changeLanguage("en")}
        className={`lang-btn ${currentLanguage === "en" ? "active" : ""}`}
        style={{
          background: "transparent",
          border: "none",
          color: currentLanguage === "en" ? "#c770f0" : "white",
          fontWeight: currentLanguage === "en" ? "bold" : "normal",
          cursor: "pointer",
          padding: "5px",
        }}
      >
        EN
      </button>
      <span style={{ color: "white" }}>|</span>
      <button
        onClick={() => changeLanguage("uz")}
        className={`lang-btn ${currentLanguage === "uz" ? "active" : ""}`}
        style={{
          background: "transparent",
          border: "none",
          color: currentLanguage === "uz" ? "#c770f0" : "white",
          fontWeight: currentLanguage === "uz" ? "bold" : "normal",
          cursor: "pointer",
          padding: "5px",
        }}
      >
        UZ
      </button>
    </div>
  );
}

export default LanguageToggle;
